import React, { useEffect, useState } from "react";
import bannerOne from "../../../../../assets/banner/bannerone.jpg";
import { getBanners } from "../../../../../api/website/home/homeApi";
import { Link } from "react-router";
const BannerOne = () => {
  const [Data, setData] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  useEffect(() => {
    getBanners(setData, setIsLoading);
  }, []);
  return (
    <div className="">
      {Data && (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <Link to={Data.linkOne} target="_blank">
            <div className="w-full h-48 overflow-hidden rounded-lg">
              <img
                className="w-full h-full object-cover"
                src={Data.bannerOne}
                alt=""
              />
            </div>
          </Link>
          <Link to={Data.linkTwo} target="_blank">
            <div className="col-span-1 lg:col-span-0 w-full h-48 overflow-hidden rounded-lg">
              <img
                className="w-full h-full object-cover"
                src={Data.bannerTwo}
                alt=""
              />
            </div>
          </Link>
          <Link to={Data.linkThree} target="_blank">
            <div className="w-full h-48 overflow-hidden rounded-lg">
              <img
                className="w-full h-full object-cover"
                src={Data.bannerThree}
                alt=""
              />
            </div>
          </Link>
        </div>
      )}
    </div>
  );
};

export default BannerOne;
